/**
 * FeatureRoute - gates a route on a billing feature key (BR-128).
 *
 * Mirrors the navigation's feature gate: the route renders until the loaded features say the key is
 * absent, at which point the caller lands on `fallbackTo` instead. Without this a gated entry would
 * disappear from the navigation yet stay reachable by URL.
 */

import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useBillingFeatures } from '../hooks/useBilling';

interface FeatureRouteProps {
  featureKey: string;
  /** Where to send the caller when the feature is absent. */
  fallbackTo: string;
  children: ReactNode;
}

export function FeatureRoute({ featureKey, fallbackTo, children }: FeatureRouteProps) {
  const { data: featuresData } = useBillingFeatures();
  if (featuresData && !featuresData.features.includes(featureKey)) {
    return <Navigate to={fallbackTo} replace />;
  }
  return <>{children}</>;
}
